/** Ticket 80985: Sofía Lizeth (626) y cuenta coordinación (2767) — Permisos Area solo vendedores y encargados INBI/FAST. */
export const IDERPS_SOFIA_PERMISOS_VENTAS = [626, 2767]

function menuTienePath (menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    if (top && top.path === path) return true
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

export function puedePermisosVendedoresEncargados (usuario) {
  return IDERPS_SOFIA_PERMISOS_VENTAS.includes(Number(usuario && usuario.iderp))
}

export function asegurarMenuPermisosVendedoresEncargados (menu, iderp) {
  if (!IDERPS_SOFIA_PERMISOS_VENTAS.includes(Number(iderp))) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []
  const path = 'PermisosArea'
  if (menuTienePath(list, path)) return list

  const action = {
    title: 'Permisos Area',
    path,
    icon: 'mdi mdi-circle-medium theme--light',
    active: 1,
  }

  let rh = list.find((m) => Number(m.idmenu) === 6 || String((m && m.title) || '').toUpperCase() === 'RH')
  if (!rh) {
    rh = { title: 'RH', idmenu: 6, path: null, items: [] }
    list.push(rh)
  }
  if (!Array.isArray(rh.items)) rh.items = []
  rh.items.push(action)
  return list
}
